"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DummyTextField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var validators_1 = require("utils/form/validators");
var StyledTextField = (0, material_1.styled)(material_1.TextField)(function (_a) {
    var _b, _c;
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    return ({
        label: {
            fontSize: 14,
            color: theme.palette.grey[600],
        },
        '& .MuiFormHelperText-root': {
            fontSize: 12,
            lineHeight: '14px',
            margin: 0,
            textAlign: 'center',
        },
        width: '100%',
        // TODO: ADD NEUTRAL to Textfield colors, there's no 'inherit' color type for Textfields
        '.MuiFormLabel-colorInfo': {
            '&.Mui-focused': { color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main },
            '.MuiInput-root:after': { borderBottomColor: theme.palette.grey[600] },
        },
        '.MuiOutlinedInput-root': __assign(__assign({ lineHeight: '20px', fieldset: { padding: 0 }, input: {
                padding: theme.spacing(0.75, 2),
                height: 'auto',
            }, ':has(.MuiInputAdornment-root)': {
                input: { paddingRight: 0 },
            } }, props.label === undefined && {
            legend: { width: 'unset' },
        }), { '&:hover:not(.Mui-focused) fieldset': {
                borderColor: (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.main,
            }, '&.MuiInputBase-sizeSmall': {
                ' .MuiInputAdornment-sizeSmall': { marginLeft: 0 },
            }, '&.MuiInputBase-colorPrimary': {
                color: theme.palette.riverstone,
                '&.Mui-focused fieldset, fieldset': {
                    borderColor: props.error ? undefined : theme.palette.primary.light,
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 1 },
                '&:hover:not(.Mui-focused) fieldset': {
                    borderColor: props.error ? undefined : theme.palette.primary.main,
                },
            } }),
    });
});
exports.DummyTextField = (0, DefaultPropsHoC_1.default)(StyledTextField, { variant: 'standard', color: 'primary' });
var TextField = function (_a) {
    var _b = _a.input, name = _b.name, onChange = _b.onChange, value = _b.value, restFormInputProps = __rest(_b, ["name", "onChange", "value"]), meta = _a.meta, helperText = _a.helperText, rest = __rest(_a, ["input", "meta", "helperText"]);
    var error = (0, validators_1.getErrorToShow)(meta);
    var subText = error !== null && error !== void 0 ? error : helperText;
    return ((0, jsx_runtime_1.jsx)(exports.DummyTextField, __assign({}, rest, { name: name, value: value, onChange: onChange, error: !!error, helperText: subText && (subText.startsWith('MD:') ? (0, jsx_runtime_1.jsx)(markdown_to_jsx_1.default, { children: subText.replace(/^MD:/, '') }) : subText), inputProps: restFormInputProps })));
};
exports.default = TextField;
